import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import axios from "axios";
import { getUserDetails } from "../utils/userDetailsUtils";

const API_CONTEXT_PATH = API_BASE_RELATIVE_PATH.replace("/ReactApp", "");
const SYSPROPS_KEY = ["sysprops"];

const getSysProps = async () => {
  const user = getUserDetails();
  const payload = {
    action: "getSysProps",
    companyid: user.companyid,
  };
  const queryString = new URLSearchParams(payload).toString();
  const response = await axios.get(`${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?${queryString}`);
  return response.data;
};

export const useGetSysPropsQuery = (enabled = true) => {
  return useQuery({
    queryKey: SYSPROPS_KEY,
    queryFn: getSysProps,
    enabled,
  });
};

const addSysProp = async (data) => {
  const user = getUserDetails();
  return axios.post(
    `${API_BASE_PATH}${API_CONTEXT_PATH}/sysprops/add?companyId=${user.companyid}`,
    data,
    { headers: { "Content-Type": "application/json" } },
  );
};

export const useAddSysPropMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: addSysProp,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: SYSPROPS_KEY }),
  });
};

const updateSysProp = async (data) => {
  const user = getUserDetails();
  const payload = {
    action: "updateSysProp",
    companyid: user.companyid,
    id: data.id,
    name: data.name,
    value: data.value,
    comment: data.comment,
  };
  const queryString = new URLSearchParams(payload).toString();
  return axios.get(`${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?${queryString}`);
};

export const useUpdateSysPropMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateSysProp,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: SYSPROPS_KEY }),
  });
};

const deleteSysProp = async (id) => {
  const user = getUserDetails();
  return axios.post(
    `${API_BASE_PATH}${API_CONTEXT_PATH}/sysprops/delete?id=${id}&companyId=${user.companyid}`,
    null,
  );
};

export const useDeleteSysPropMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteSysProp,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: SYSPROPS_KEY }),
  });
};

export default {
  useGetSysPropsQuery,
  useAddSysPropMutation,
  useUpdateSysPropMutation,
  useDeleteSysPropMutation,
};
